import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AccessCodesPanel } from "../../components/access-codes/access-codes-panel";
import { AccessRulesPanel } from "../../components/access-rules/access-rules-panel";
import { PageTabs } from "../../components/common/page-tabs";
import { tabbedSearch } from "../../lib/list-page/tab-search";

const TABS = ["codes", "rules"] as const;
type Tab = (typeof TABS)[number];

/**
 * Settings › Zone Access — the access codes and the zone access rules, one
 * menu item, the tab in `?tab=` (absent = codes). The old
 * `/settings/access-codes` and `/settings/access-defaults` redirect here.
 */
export const Route = createFileRoute("/_app/settings/zone-access")({
	validateSearch: tabbedSearch(TABS),
	component: ZoneAccessPage,
});

function ZoneAccessPage() {
	const { t } = useTranslation("nav");
	const tab: Tab = Route.useSearch().tab ?? "codes";
	const navigate = Route.useNavigate();
	return (
		<div className="flex min-w-0 flex-col gap-[1rem]">
			<PageTabs
				label={t("items.zoneAccess")}
				tabs={[
					{ key: "codes", label: t("items.accessCodes") },
					{ key: "rules", label: t("items.accessDefaults") },
				]}
				current={tab}
				onChange={(next) => void navigate({ search: { tab: next === "codes" ? undefined : next } })}
			/>
			{tab === "codes" ? <AccessCodesPanel /> : <AccessRulesPanel />}
		</div>
	);
}
